import { Language } from '^/types';

export default {
  name: {
    [Language.KO_KR]: '이름',
    [Language.EN_US]: 'Name',
  },
  email: {
    [Language.KO_KR]: '이메일',
    [Language.EN_US]: 'Email',
  },
  team: {
    [Language.KO_KR]: '조직',
    [Language.EN_US]: 'Team',
  },
  featureToggle: {
    ess: {
      [Language.KO_KR]: '안전관리',
      [Language.EN_US]: 'Site Logistics',
    },
  },
  authority: {
    [Language.KO_KR]: '권한',
    [Language.EN_US]: 'Authority',
  },
  delete: {
    [Language.KO_KR]: '삭제',
    [Language.EN_US]: 'Delete',
  },
  adminRole: {
    [Language.KO_KR]: '보기 • 수정/삭제 • 업로드 • 공유',
    [Language.EN_US]: 'View • Edit/Delete • Upload • Share',
  },
  pilotRole: {
    [Language.KO_KR]: '보기 • 수정/삭제 • 업로드 ',
    [Language.EN_US]: 'View • Edit/Delete • Upload',
  },
  memberRole: {
    [Language.KO_KR]: '보기 • 수정/삭제 ',
    [Language.EN_US]: 'View • Edit/Delete ',
  },
  viewerRole: {
    [Language.KO_KR]: '보기 전용 ',
    [Language.EN_US]: 'View only',
  },
};
